import { ModalHeader, Modal, ModalBody } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import styles from '../dashboard.module.scss'
import { handleNavigation } from '../../../utils/functions'

const SettingsModal = ({ isOpen, closeModal }) => {
  const navigate = useNavigate()

  // ** Root
  return (
    <Modal isOpen={isOpen} centered size="sm">
      <ModalHeader toggle={closeModal}>
        <span className={styles.modalTitle}>Settings</span>
      </ModalHeader>
      <ModalBody>
        <div className={`d-flex align-content-stretch flex-column ${styles.gap15}`} >
          <button
            type="button"
            className={styles.btn}
            onClick={() => {
              handleNavigation(navigate, '/templates')
              closeModal()
            }}
          >
            Templates
          </button>
          <button
            type="button"
            className={styles.btn}
            onClick={() => {
              handleNavigation(navigate, '/referral-specialities')
              closeModal()
            }}
          >
            Referral Specialities
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}
export default SettingsModal
